var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaShowreel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.2615C7.939 14.2615 7.8775 14.2478 7.821 14.2184C7.686 14.1493 7.6 14.0087 7.6 13.8554V6.54462C7.6 6.39129 7.6855 6.24965 7.821 6.18161C7.9565 6.11358 8.1185 6.1278 8.24 6.21969L13.04 9.87508C13.141 9.95123 13.2 10.0726 13.2 10.2C13.2 10.3274 13.141 10.4488 13.04 10.5249L8.24 14.1803C8.1695 14.2341 8.085 14.2615 8 14.2615ZM8.4 7.35692V13.0431L12.1335 10.2L8.4 7.35692ZM17.6 3.70154H2.4C2.179 3.70154 2 3.88329 2 4.10769V16.2923C2 16.5167 2.179 16.6985 2.4 16.6985H17.6C17.821 16.6985 18 16.5167 18 16.2923V4.10769C18 3.88329 17.821 3.70154 17.6 3.70154ZM4.4 11.0125H2.8V9.38787H4.4V11.0125ZM4.4 8.57538H2.8V6.95077H4.4V8.57538ZM2.8 11.8246H4.4V13.4492H2.8V11.8246ZM5.2 4.51404H14.8V15.8863H5.2V4.51404ZM15.6 9.38787H17.2V11.0125H15.6V9.38787ZM15.6 8.57538V6.95077H17.2V8.57538H15.6ZM15.6 11.8246H17.2V13.4492H15.6V11.8246ZM17.2 6.13865H15.6V4.51404H17.2V6.13865ZM4.4 4.51404V6.13865H2.8V4.51404H4.4ZM2.8 14.2617H4.4V15.8863H2.8V14.2617ZM15.6 15.8863V14.2617H17.2V15.8863H15.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaShowreel);
export default __webpack_public_path__ + "static/media/media-showreel.b4a09a8e17bceba1abbc51ae91bbc8b5.svg";
export { ForwardRef as ReactComponent };